import React, { useMemo } from "react";
import { Separator } from "../ui/separator";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

interface CartOrderSummaryProps {
  cartItems?: any[];
  cartTotal?: number;
  cartItemCount?: number;
}

const CartOrderSummary = ({ 
  cartItems = [], 
  cartTotal = 0, 
  cartItemCount = 0 
}: CartOrderSummaryProps) => {
  const subtotal = useMemo(
    () => cartTotal || cartItems?.reduce((total, item) => total + ((item?.price || item?.variant?.price) * (item?.quantity ?? 1)), 0) || 0,
    [cartItems, cartTotal]
  );
  
  return (
    <>
      <div className="border rounded-lg p-6">
        <h2 className="text-xl font-bold mb-4">Order Summary</h2>

        <div className="space-y-4">
          <div className="flex justify-between">
            <span className="text-gray-500">Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-500">Shipping</span>
            <span className="text-gray-500">Calculated at checkout</span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-500">Tax</span>
            <span className="text-gray-500">Calculated at checkout</span>
          </div>

          <Separator />
          <div className="flex justify-between font-medium mb-4">
            <span>Total</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <Link to="/checkout" className="w-full ">
          <Button className="w-full mt-4 bg-black hover:bg-gray-800 text-white">
            Proceed to Checkout
          </Button>
            </Link>
        </div>
      </div>
    </>
  );
};

export default CartOrderSummary;
